export function getInitialDataSource(options = [], returnObject = false) {
  let selectedEntity = options.find(({ selected }) => !!selected)

  // Pre-select the first option if none is selected
  if (!selectedEntity && options.length > 0) {
    selectedEntity = options[0]
  }

  return returnObject
    ? selectedEntity
    : (selectedEntity && (selectedEntity.id || selectedEntity.name)) || ``
}

export function composeIntegrationConfig(dataType, entities, dataSource) {
  return {
    [`${dataType}Id`]: dataSource,
    [`${dataType}Name`]: entities.find(({ id }) => id === dataSource).name,
  }
}
